"use strict";

exports["default"] = function (obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
};

exports.__esModule = true;


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/jxt-xmpp/~/babel-runtime/helpers/interop-require-default.js
// module id = 460
// module chunks = 2